<template>
  <v-dialog persistent v-model="value" max-width="300">
    <v-form @submit.prevent="save">
      <v-card>
        <v-card-title class="headline">{{$t('Pages.WarehouseTransactions.fix')}}</v-card-title>

        <v-card-text>
          <v-layout column wrap>
            <v-flex xs12 md5>
              <v-textarea
                v-model="fixTransaction.note"
                :label="$t('Pages.UserCheckoutFormStatuses.model.note')"
                type="number"
                color="indigo"
                name="note"
              />
              <p class="font-weight-medium text-xs-center">{{$t('Pages.WarehouseTransactions.fix_info')}}</p>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn @click="close">
            {{$t('Core.Fields.close')}}
          </v-btn>

          <v-btn dark color="success dark1" type="submit">
            {{$t('Core.Fields.save')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  import i18n from '@/i18n'
  export default {
  components: {},
  props: ['value', 'transactionId'],
  data: () => ({
    fixTransaction: {
      note: ""
    },
  }),
  methods: {
    close(){
      this.fixTransaction = {};
      this.$emit('close')
    },
    save(){
      this.repositories.warehouseTransaction.fixed(
        this.transactionId,
        { user_checkout_form_id: this.$route.params.id, note: this.fixTransaction.note },
        'fixedTransaction')
          .then(response => {
            this.$toast.success(response.data.message)
            this.$emit('refresh');
            this.close();
          })
    }
  },
}
</script>

<style lang="scss">

</style>